import { z } from 'zod/v4';

import { fleetErrorSchema } from './fleet-error.schema';

export const fleetMessageSchema = z.object({
  message: z.string().nullable(),
  error: fleetErrorSchema.optional(),
});
